import React from 'react';
import { useUserStore } from '@store/userStore';
import type { ChatMessage as ChatMessageType } from '@store/chatStore';
import styles from './ChatMessage.module.css';

interface ChatMessageProps {
  message: ChatMessageType;
}

export const ChatMessage: React.FC<ChatMessageProps> = ({ message }) => {
  const playerId = useUserStore((state) => state.playerId);
  const isOwnMessage = message.playerId === playerId;
  
  const formatTime = (timestamp: number) => {
    const date = new Date(timestamp);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };
  
  if (message.type === 'system') {
    return (
      <div className={styles.systemMessage}>
        {message.message}
      </div>
    );
  }
  
  if (message.type === 'move') {
    return (
      <div className={styles.moveMessage}>
        <span className={styles.moveNotation}>{message.message}</span>
      </div>
    );
  }
  
  return (
    <div className={`${styles.message} ${isOwnMessage ? styles.own : ''}`}>
      <div className={styles.header}>
        <span className={styles.playerName}>{message.playerName}</span>
        <span className={styles.time}>{formatTime(message.timestamp)}</span>
      </div>
      <div className={styles.content}>
        {message.message}
      </div>
    </div>
  );
};